import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { WithPageTreeStateUpdaterProps } from '@confluence/page-tree-refresh-state-container/entry-points/withPageTreeStateUpdater.ts';
import type { SplitPageResultsProps } from '../src/components/SplitPageResults/SplitPageResults.tsx';

export const SplitPageResultsLoader: LoadableType<
	Omit<Omit<SplitPageResultsProps & WithPageTreeStateUpdaterProps, 'flags'>, 'pageTreeStateUpdater'>
> = LoadablePaint({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-SplitPageResults" */ '../src/components/SplitPageResults/SplitPageResults.tsx'
			)
		).SplitPageResults,
});
